import { Component, OnInit } from "@angular/core";
import { CommonModule } from '@angular/common';
import { AutenticacaoService } from "../../services";
import { Router } from '@angular/router';
import { AcessibilidadeService } from "../../services/acessibilidade/acessibilidade.service";

@Component({
  selector: 'app-menu-acessibilidade',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './menu-acessibilidade.component.html',
  styleUrl: './menu-acessibilidade.component.scss'
})
export class MenuAcessibilidadeComponent implements OnInit{
  fontSizeLevel = 0;
  highContrast = false;

  constructor(
    private autenticacaoService: AutenticacaoService,
    public acessibilidadeService: AcessibilidadeService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.acessibilidadeService.state$.subscribe((state:any) => {
      this.fontSizeLevel = state.fontSize;
      this.highContrast = state.highContrast;
    });
  }

  aumentarFonte(): void {
    this.acessibilidadeService.aumentarFonte();
  }

  diminuirFonte(): void {
    this.acessibilidadeService.diminuirFonte();
  }

  resetarTamanhoFonte(): void {
    this.acessibilidadeService.resetarTamanhoFonte();
  }

  habilitarContraste(): void {
    this.acessibilidadeService.habilitarContraste();
  }

  pularPara(elementId: string): void {
    this.acessibilidadeService.pularParaElemento(elementId);
  }

  podeAumentar(): boolean {
    return this.fontSizeLevel < 1;
  }

  podeDiminuir(): boolean {
    return this.fontSizeLevel > -1;
  }

  isLoggedIn(): boolean {
    return this.autenticacaoService.isLogado();
  }

  logout(): void {
    this.autenticacaoService.logout();
  }

  login(): void {
    // Redirecionar para a página de login
    this.router.navigate(['/login']);
  }
}
